import React from 'react';
import BatchDetails from './BatchDetails';

const PrintFailures = props => {
  const { batchData, printFailures, getTagDetails, startAndEndDate, onCancel, tagValues, dateFilterApplied } = props;

  return (
    <BatchDetails
      batchData={batchData}
      printFailures={printFailures}
      getTagDetails={getTagDetails}
      startAndEndDate={startAndEndDate}
      onCancel={onCancel}
      tagValues={tagValues}
      dateFilterApplied={dateFilterApplied}
    />
  );
};

export default PrintFailures;
